import { Serializable } from '../../../core/models/serializable';
import { RangeFilter } from '@admin/shared/models/range.model';

export class CvDatabaseReportFilterModel
  implements Serializable<CvDatabaseReportFilterModel>
{
  fromObject(object: any): CvDatabaseReportFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      Dates: this.dates,
      WebsiteId: this.websiteId,
      ExcludeInternalCustomers: this.excludeInternalCustomers,
    };
  }

  public dates: RangeFilter<Date>;
  public websiteId: number;
  public excludeInternalCustomers: boolean;
}
